<template>
    <base-card>
        <h2>Page Not Found</h2>
        <p>
            This page could not be found - maybe check out our <router-link to="/coaches">
            coaches </router-link>
        </p>
    </base-card>
</template>